import React, { Component } from 'react'
import { string, bool, func } from 'prop-types'

import './Checkbox.css'

class Checkbox extends Component {
  buildID(seed) {
    if (!seed) {
      return this.getRandomID()
    }

    return seed.replace(' ', '-')
  }

  getRandomID() {
    const MIN = 1
    const MAX = 9999
    return Math.floor(Math.random() * (MAX - MIN)) + MIN
  }

  render() {
    const { checked, label, onChange, ariaLabel } = this.props
    const id = this.buildID(label)

    return (
      <div className="checkbox">
        <input
          id={id}
          className="checkbox__input"
          type="checkbox"
          aria-label={ariaLabel}
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={id} className="checkbox__label">
          {label}
        </label>
      </div>
    )
  }
}

Checkbox.propTypes = {
  checked: bool,
  onChange: func,
  label: string,
  ariaLabel: string,
}

export { Checkbox }
